module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.user) ? _c('b-card', {
    staticClass: "mb-2",
    attrs: {
      "header-text-variant": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": _vm.$t('userAdministration.userDetails')
    }
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userLogin')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.user.login))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userName')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.user.name))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userEmail')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.user.email))])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "role": "tablist"
    }
  }, [_c('b-card-header', {
    staticClass: "p-1",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.userRoles",
      modifiers: {
        "userRoles": true
      }
    }],
    attrs: {
      "block": "",
      "href": "#",
      "variant": "secondary"
    }
  }, [_vm._v(_vm._s(_vm.$t('userAdministration.userRolesClaims')))])], 1), _vm._v(" "), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "userRoles",
      "accordion": "info-accordion",
      "role": "tabpanel"
    }
  }, [_c('b-card', {
    staticClass: "mb-2"
  }, [(_vm.user.creationRoles) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-list-group', _vm._l((_vm.user.creationRoles), function(role) {
    return _c('b-list-group-item', {
      key: role,
      attrs: {
        "variant": "secondary"
      }
    }, [_vm._v("\r\n                                " + _vm._s(_vm.$t('userAdministration.' + role)) + "\r\n                            ")])
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.user.creationClaims) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-list-group', _vm._l((_vm.user.creationClaims), function(claim) {
    return _c('b-list-group-item', {
      key: claim,
      attrs: {
        "variant": "secondary"
      }
    }, [_vm._v("\r\n                                " + _vm._s(_vm.$t('userAdministration.' + claim)) + "\r\n                            ")])
  }), 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-card-header', {
    staticClass: "p-1",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.passwordChange",
      modifiers: {
        "passwordChange": true
      }
    }],
    attrs: {
      "block": "",
      "href": "#",
      "variant": "secondary"
    }
  }, [_vm._v(_vm._s(_vm.$t('userAdministration.changePassword')))])], 1), _vm._v(" "), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "passwordChange",
      "accordion": "info-accordion",
      "role": "tabpanel"
    }
  }, [_c('form', {
    ref: "changePasswordForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.changeUserPassword($event)
      }
    }
  }, [_c('b-card', {
    staticClass: "mb-3"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.oldPassword')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password.oldPassword),
      callback: function($$v) {
        _vm.$set(_vm.password, "oldPassword", $$v)
      },
      expression: "password.oldPassword"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.newPassword')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.password, "newPassword", $$v)
      },
      expression: "password.newPassword"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.confirmNewPassword')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password.confirmNewPassword),
      callback: function($$v) {
        _vm.$set(_vm.password, "confirmNewPassword", $$v)
      },
      expression: "password.confirmNewPassword"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-0"
  }, [_c('b-col', [_c('small', [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userPasswordRequirement.0')))])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-0"
  }, [_c('b-col', [_c('small', [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userPasswordRequirement.1')))])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-0"
  }, [_c('b-col', [_c('small', [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userPasswordRequirement.2')))])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-0"
  }, [_c('b-col', [_c('small', [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userPasswordRequirement.3')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "success",
      "disabled": _vm.hasValidPasswords || _vm.load
    }
  }, [_vm._v("\r\n                            " + _vm._s(_vm.$t('userAdministration.apply')) + "\r\n                            "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('b-card-header', {
    staticClass: "p-1",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.personalInfoChange",
      modifiers: {
        "personalInfoChange": true
      }
    }],
    attrs: {
      "block": "",
      "href": "#",
      "variant": "secondary"
    }
  }, [_vm._v(_vm._s(_vm.$t('userAdministration.personalInformationChange')))])], 1), _vm._v(" "), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "personalInfoChange",
      "accordion": "info-accordion",
      "role": "tabpanel"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.validateUserInformation($event)
      }
    }
  }, [_c('b-card', {
    staticClass: "mb-3",
    attrs: {
      "header": _vm.$t('userAdministration.userDetails')
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userName')
    }
  }, [_c('b-form-input', {
    class: {
      'error': _vm.$v.user.name.$error
    },
    attrs: {
      "name": "user.name"
    },
    model: {
      value: (_vm.user.name),
      callback: function($$v) {
        _vm.$set(_vm.user, "name", $$v)
      },
      expression: "user.name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userEmail')
    }
  }, [_c('b-form-input', {
    class: {
      'error': _vm.$v.user.email.$error
    },
    attrs: {
      "type": "email",
      "name": "user.email"
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.editUserInformationModal",
      modifiers: {
        "editUserInformationModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": _vm.load
    }
  }, [_vm._v("\r\n                            " + _vm._s(_vm.$t('userAdministration.apply')) + "\r\n                            "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('b-card-header', {
    staticClass: "p-1",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.personalSettings",
      modifiers: {
        "personalSettings": true
      }
    }],
    attrs: {
      "block": "",
      "href": "#",
      "variant": "secondary"
    }
  }, [_vm._v(_vm._s(_vm.$t('userSettings.regionalHeader')))])], 1), _vm._v(" "), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "personalSettings",
      "role": "tabpanel"
    }
  }, [_c('b-card', {
    staticClass: "mb-3",
    attrs: {
      "header": _vm.$t('userSettings.regionalSubheader')
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userSettings.language')
    }
  }, [_c('b-form-select', {
    staticClass: "mt-3",
    attrs: {
      "options": _vm.personal.language.options,
      "size": "sm"
    },
    model: {
      value: (_vm.personal.language.value),
      callback: function($$v) {
        _vm.$set(_vm.personal.language, "value", $$v)
      },
      expression: "personal.language.value"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userSettings.dateFormat')
    }
  }, [_c('b-form-select', {
    staticClass: "mt-3",
    attrs: {
      "options": _vm.personal.dateFormat.options,
      "size": "sm"
    },
    model: {
      value: (_vm.personal.dateFormat.value),
      callback: function($$v) {
        _vm.$set(_vm.personal.dateFormat, "value", $$v)
      },
      expression: "personal.dateFormat.value"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userSettings.decimalFormat')
    }
  }, [_c('b-form-select', {
    staticClass: "mt-3",
    attrs: {
      "options": _vm.personal.decimalFormat.options,
      "size": "sm"
    },
    model: {
      value: (_vm.personal.decimalFormat.value),
      callback: function($$v) {
        _vm.$set(_vm.personal.decimalFormat, "value", $$v)
      },
      expression: "personal.decimalFormat.value"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userSettings.csvSeparator')
    }
  }, [_c('b-form-select', {
    staticClass: "mt-3",
    attrs: {
      "options": _vm.personal.csvDelimmeter.options,
      "size": "sm"
    },
    model: {
      value: (_vm.personal.csvDelimmeter.value),
      callback: function($$v) {
        _vm.$set(_vm.personal.csvDelimmeter, "value", $$v)
      },
      expression: "personal.csvDelimmeter.value"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-row', {
    staticClass: "mt-3 text-right",
    attrs: {
      "align-h": "end"
    }
  }, [_c('b-col', {
    staticClass: "mr-3",
    attrs: {
      "cols": "*"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success",
      "disabled": _vm.load
    },
    on: {
      "click": _vm.saveRegional
    }
  }, [_vm._v("\r\n                                " + _vm._s(_vm.$t('userAdministration.apply')) + "\r\n                                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.hasAdminClaim) ? _c('b-card-header', {
    staticClass: "p-1",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.hiddenButtonCollapse",
      modifiers: {
        "hiddenButtonCollapse": true
      }
    }],
    attrs: {
      "block": "",
      "href": "#",
      "variant": "secondary"
    }
  }, [_vm._v("Додатне функције")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasAdminClaim) ? _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "hiddenButtonCollapse",
      "role": "tabpanel"
    }
  }, [_c('b-container', [_c('b-row', {
    staticClass: "text-center"
  }, [_c('b-col', [_c('b-button', {
    attrs: {
      "variant": "danger",
      "disabled": _vm.load
    },
    on: {
      "click": _vm.causeFatal
    }
  }, [_vm._v("\r\n                            \"Sentry\" - тест\r\n                            "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('div', [_c('b-modal', {
    attrs: {
      "id": "editUserInformationModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.validateUserInformation
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('userAdministration.personalInformationChangeConfirmation')) + "\r\n            ")])], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    attrs: {
      "id": "editRegistrationInformationModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.validateRegistrationInformation
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('userAdministration.registrationInformationChangeConfirmation')) + "\r\n            ")])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-eba14a06", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eba14a06","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./src/components/home/user-administration/user-profile/user-profile.html
// module id = 810
// module chunks = 1